import React, { useState, useEffect } from "react";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import {
  ArrowReturnIcon,
  CopyIcon,
  EditIcon,
  ExportIcon,
  FeedbackIcon,
  PersonIcon,
} from "../../Assets/AllSvg";
import { AiOutlinePlus } from "react-icons/ai";
import { BsPlusCircleFill, BsThreeDotsVertical } from "react-icons/bs";
import { BiRightArrowAlt } from "react-icons/bi";
import AddCustomerModel from "../AddCustomerModel/AddCustomerModel";
import {
  Popover,
  PopoverContent,
  PopoverHandler,
} from "@material-tailwind/react";
import ExportModel from "../ExportModel/ExportModel";
import { IoChevronDown } from "react-icons/io5";
import { HiChevronUpDown, HiOutlineChevronLeft } from "react-icons/hi2";
import CustomerTable from "../CustomerTable/CustomerTable";
import DeleteCustomerModel from "../DeleteCustomerModel/DeleteCustomerModel";
import CopydataModal from "../CopydataModal/CopydataModal";
import { GetCustomer } from "../API/CustomerAPI";

const Customer = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [loader, setLoader] = useState(true);
  const [sendData, setSendData] = useState('')
  const [moreFilter, setMoreFilter] = useState("default");
  const [first, setFirst] = useState([]);
  const [deleteCust, setDeleteCust] = useState(false);
  const [getCust, setGetCust] = useState(false);
  const [copyData, setCopyData] = useState(false);
  const [cancelRequest, setCancelRequest] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [custAll, setCustAll] = useState([]);
  const [data, setData] = useState({
    email: "",
    card: "",
    type: "",
    date: "",
  });
  const [userInfo, setUserInfo] = useState({
    defaultMethod: true,
    created: true,
    customerID: false,
    cardName: false,
    customer: false,
    email: true,
    subscription: false,
    description: false,
  });
  const [isTrue, setIsTrue] = useState(false)

  const triggers = {
    onMouseEnter: () => setOpenPopover(true),
    onMouseLeave: () => setOpenPopover(false),
  };

  const clearFilter = () => {
    setData({ email: "", card: "", type: "", date: "" });
    setCustomers(custAll);
  };

  const getCustomers = async () => {
    setLoader(true);
    if(open === false){
      const getdata = await GetCustomer();
  
      const userID = localStorage.getItem("user")
      setCustomers(getdata && getdata.filter((val) => val.user_id === userID));
      setCustAll(getdata && getdata.filter((val) => val.user_id === userID));
    }
    setLoader(false);
  };

  const handleFilterByEmail = () => {
    if(data.email !== ''){
      const filtrData = custAll.filter((val) => val.account_email === data.email);
      setCustomers(filtrData);
      setIsTrue(false)
    } else {
      setCustomers(custAll)
      setIsTrue(false)
    }
  };

  useEffect(() => {
    getCustomers();
  }, [open, getCust]);

  return (
    <>
      <div>
        <DashboardHeader />
        <div className="max-w-[1690px] mx-auto lg:px-[40px] px-[20px] py-[8px] w-full text-[#414552]">
          <div className="flex xs:flex-row flex-col xs:gap-0 gap-3 justify-between items-center xs:mt-5 mt-2">
            <span className="text-[#30313d] sm:text-[28px] text-[20px] font-bold">Customers</span>
            <div className="flex gap-2">
              <button
                className="flex gap-2 text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]"
                onClick={() => setOpen(true)}
              >
                <AiOutlinePlus className="text-white" />
                Add customer{" "}
                <div className="bg-[#8d7ffa] px-[4px] h-[15px] text-[13px] flex justify-center items-center rounded">
                  n
                </div>
              </button>
              <Popover placement="bottom-end">
                <PopoverHandler>
                  <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2">
                    <FeedbackIcon />
                    Feedback
                  </button>
                </PopoverHandler>
                <PopoverContent className="p-0 max-w-[360px] w-full text-[#414552]">
                  <div className="font-medium p-[12px] border-b-[1px] border-[#ebeef1] text-base">
                    <textarea
                      rows="4"
                      className="w-full focus:outline-none text-[14px] font-normal"
                      placeholder="Provide us feedback on this page: Let us know how we can improve your experience with customers on Stripe."
                    ></textarea>
                  </div>
                  <div className="font-medium p-[12px] bg-[#f6f8fa] text-base">
                    <div className="flex justify-between gap-2">
                      <button
                        dismiss
                        className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-medium p-[0_8px] bg-white"
                      >
                        Cancel
                      </button>
                      <button
                        className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-medium p-[0_8px] opacity-50 flex gap-1 items-center"
                        disabled
                      >
                        Send feedback
                        <div className="bg-[#8d7ffa] px-[4px] w-max h-[15px] text-[13px] flex justify-center items-center rounded">
                          ctrl
                        </div>
                        +
                        <div className="bg-[#8d7ffa] px-[4px] w-max h-[15px] text-[13px] flex justify-center items-center rounded">
                          enter
                        </div>
                      </button>
                    </div>
                    <div className="flex gap-1 text-xs mt-[8px]">
                      Have a specific issue?{" "}
                      <span className="text-[#625afa]">Contact support</span> or{" "}
                      <span className="text-[#625afa]">read our docs.</span>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </div>
          </div>
          <div className="sm:mt-5 mt-8 flex md:flex-row flex-col md:gap-0 gap-4 justify-between border-b-[1px] border-[#d5d5d6] md:pb-5 pb-3">
            <div className="flex gap-2 items-center flex-wrap">
              <Popover
                placement="bottom-start"
                animate={{
                  mount: { scale: 1, y: 0 },
                  unmount: { scale: 0, y: 25 },
                }}
                // open={isTrue}
              >
                <PopoverHandler onClick={() => setIsTrue(true)}>
                  <div className="px-[8px] cursor-pointer hover:bg-[#f6f8fa] text-[12px] rounded-full flex gap-1 h-[25px] text-[#687385] items-center border-[1px] border-dashed border-[#c0c8d2]">
                    <BsPlusCircleFill className="text-[12px] text-[#687385]" />
                    Email
                    {data.email === "" ? null : (
                      <div className="flex gap-1 items-center">
                        |
                        <div className="text-[#635bff] translate-y-[-1px]">
                          {data.email}
                        </div>
                        <IoChevronDown />
                      </div>
                    )}
                  </div>
                </PopoverHandler>
                <PopoverContent className="max-w-[260px] w-full text-[#414552] p-[12px] text-[14px]">
                  <span className="font-semibold">Filter by Email</span>
                  <div className="flex items-center gap-2 mt-[12px]">
                    <span className="whitespace-nowrap">is equal to</span>
                    <input
                      type="text"
                      value={data.email}
                      onChange={(e) =>
                        setData({ ...data, email: e.target.value })
                      }
                      className="input_focus_shadow font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[24px] text-[13px]"
                    />
                  </div>
                  <button
                    className="mt-[16px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]"
                    onClick={handleFilterByEmail}
                  >
                    Apply
                  </button>
                </PopoverContent>
              </Popover>

              <Popover
                placement="bottom-start"
                animate={{
                  mount: { scale: 1, y: 0 },
                  unmount: { scale: 0, y: 25 },
                }}
              >
                <PopoverHandler>
                  <div className="px-[8px] cursor-pointer hover:bg-[#f6f8fa] text-[12px] rounded-full flex gap-1 h-[25px] text-[#687385] items-center border-[1px] border-dashed border-[#c0c8d2]">
                    <BsPlusCircleFill className="text-[12px] text-[#687385]" />
                    Card
                    {data.card === "" ? null : (
                      <div className="flex gap-1 items-center">
                        |
                        <div className="text-[#635bff] translate-y-[-1px]">
                          {data.card}
                        </div>
                        <IoChevronDown />
                      </div>
                    )}
                  </div>
                </PopoverHandler>
                <PopoverContent className="max-w-[260px] w-full text-[#414552] p-[12px] text-[14px]">
                  <span className="font-semibold">Filter by Card</span>
                  <div className="flex items-center gap-2 mt-[7px]">
                    <div className="relative mt-1 w-full">
                      <select
                        className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none"
                        value={data.card}
                        onChange={(e) =>
                          setData({ ...data, card: e.target.value })
                        }
                      >
                        <option value="has an active card">
                          has an active card
                        </option>
                        <option value="does not have an active card">
                          does not have an active card
                        </option>
                      </select>
                      <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[25px]" />
                    </div>
                  </div>
                  <button
                    className="mt-[16px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]"
                    onClick={() => { }}
                  >
                    Apply
                  </button>
                </PopoverContent>
              </Popover>

              <Popover
                placement="bottom-start"
                animate={{
                  mount: { scale: 1, y: 0 },
                  unmount: { scale: 0, y: 25 },
                }}
              >
                <PopoverHandler>
                  <div className="px-[8px] cursor-pointer hover:bg-[#f6f8fa] text-[12px] rounded-full flex gap-1 h-[25px] text-[#687385] items-center border-[1px] border-dashed border-[#c0c8d2]">
                    <BsPlusCircleFill className="text-[12px] text-[#687385]" />
                    Created Date
                    {data.date === "" ? null : (
                      <div className="flex gap-1 items-center">
                        |
                        <div className="text-[#635bff] translate-y-[-1px]">
                          {data.date}
                        </div>
                        <IoChevronDown />
                      </div>
                    )}
                  </div>
                </PopoverHandler>
                <PopoverContent className="max-w-[260px] w-full text-[#414552] p-[12px] text-[14px]">
                  <span className="font-semibold">Filter by Created date</span>
                  <div className="flex items-center gap-2 mt-[7px]">
                    <div className="relative mt-1 w-full">
                      <select
                        className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none"
                        value={data.date}
                        onChange={(e) =>
                          setData({ ...data, date: e.target.value })
                        }
                      >
                        <option value="is in the last">is in the last</option>
                        <option value="is equal to">is equal to</option>
                        <option value="is between">is between</option>
                        <option value="is after">is after</option>
                        <option value="is on or after">is on or after</option>
                        <option value="is before">is before</option>
                        <option value="is before or on">is before or on</option>
                      </select>
                      <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[25px]" />
                    </div>
                  </div>
                  <div className="flex gap-4 mt-3 items-center">
                    <ArrowReturnIcon />
                    <div className="flex gap-2 items-center w-full">
                      <input
                        type="text"
                        className="input_focus_shadow text-[#404452] font-normal px-3 w-[60px] bg-white rounded-[6px] focus:outline-none h-[24px] text-[14px]"
                      />
                      <div className="relative mt-1 w-[100px]">
                        <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[24px] text-[14px] appearance-none">
                          <option value="days">days</option>
                          <option value="month">month</option>
                        </select>
                        <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[20px]" />
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-4 mt-3 items-center">
                    <span className="w-max">Time zone:</span>
                    <div className="flex gap-2 items-center">
                      <div className="relative flex items-center">
                        <div className="flex items-center">
                          <input
                            id="zone-1"
                            name="Time-zone"
                            type="radio"
                            className="h-[16px] w-[16px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                            defaultChecked
                          />
                        </div>
                        <div className="ml-2 text-sm">
                          <label htmlFor="zone-1" className="select-none font-medium">
                            GMT+5:30
                          </label>
                        </div>
                      </div>
                      <div className="relative flex items-center">
                        <div className="flex items-center">
                          <input
                            id="zone-2"
                            name="Time-zone"
                            type="radio"
                            className="h-[16px] w-[16px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                          />
                        </div>
                        <div className="ml-2 text-sm">
                          <label htmlFor="zone-2" className="select-none font-medium">
                            UTC
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="mt-[16px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]"
                    onClick={() => { }}
                  >
                    Apply
                  </button>
                </PopoverContent>
              </Popover>

              <Popover
                placement="bottom-start"
                animate={{
                  mount: { scale: 1, y: 0 },
                  unmount: { scale: 0, y: 25 },
                }}
              >
                <PopoverHandler>
                  <div className="px-[8px] cursor-pointer hover:bg-[#f6f8fa] text-[12px] rounded-full flex gap-1 h-[25px] text-[#687385] items-center border-[1px] border-dashed border-[#c0c8d2]">
                    <BsPlusCircleFill className="text-[12px] text-[#687385]" />
                    Type
                    {data.type === "" ? null : (
                      <div className="flex gap-1 items-center">
                        |
                        <div className="text-[#635bff] translate-y-[-1px]">
                          {data.type}
                        </div>
                        <IoChevronDown />
                      </div>
                    )}
                  </div>
                </PopoverHandler>
                <PopoverContent className="max-w-[260px] w-full text-[#414552] p-[12px] text-[14px]">
                  <span className="font-semibold">Filter by Card</span>
                  <div className="flex items-center gap-2 mt-[7px]">
                    <div className="relative mt-1 w-full">
                      <select
                        className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none"
                        value={data.type}
                        onChange={(e) =>
                          setData({ ...data, type: e.target.value })
                        }
                      >
                        <option value="Customer account">
                          Customer account
                        </option>
                        <option value="Guest">Guest</option>
                      </select>
                      <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[25px]" />
                    </div>
                  </div>
                  <button
                    className="mt-[16px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]"
                    onClick={() => { }}
                  >
                    Apply
                  </button>
                </PopoverContent>
              </Popover>

              <Popover
                placement="bottom-end"
                animate={{
                  mount: { scale: 1, y: 0 },
                  unmount: { scale: 0, y: 25 },
                }}
              >
                <PopoverHandler>
                  <div className="px-[8px] cursor-pointer hover:bg-[#f6f8fa] text-[12px] rounded-full flex gap-1 h-[25px] text-[#687385] items-center border-[1px] border-dashed border-[#c0c8d2]">
                    <BsPlusCircleFill className="text-[12px] text-[#687385]" />
                    More filters
                  </div>
                </PopoverHandler>
                <PopoverContent className="max-w-[260px] w-full text-[#414552] p-[12px] text-[14px]">
                  {moreFilter === "default" && (
                    <div>
                      <button
                        onClick={() => setMoreFilter("discount")}
                        className="text-[#625afa] hover:text-gray-800 text-[14px] font-medium flex gap-2 items-center"
                      >
                        <BsPlusCircleFill />
                        Discount
                      </button>
                      <button
                        onClick={() => setMoreFilter("delinquent")}
                        className="text-[#625afa] mt-2 hover:text-gray-800 text-[14px] font-medium flex gap-2 items-center"
                      >
                        <BsPlusCircleFill />
                        Delinquent
                      </button>
                    </div>
                  )}
                  {moreFilter === "discount" && (
                    <div className="text-[#414552]">
                      <div className="flex gap-4 items-center">
                        <button
                          onClick={() => setMoreFilter("default")}
                          className="rounded input_focus_shadow bg-white px-[9px] py-[4px]"
                        >
                          <HiOutlineChevronLeft />
                        </button>
                        <span className="font-semibold">Filter by Discount</span>
                      </div>
                      <div className="relative mt-3 w-full">
                        <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none">
                          <option value="Does not have a discount">
                            Does not have a discount
                          </option>
                          <option value="has a discount">has a discount</option>
                        </select>
                        <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[25px]" />
                      </div>
                      <button className="mt-[15px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]">
                        Apply
                      </button>
                    </div>
                  )}
                  {moreFilter === "delinquent" && (
                    <div className="text-[#414552]">
                      <div className="flex gap-4 items-center">
                        <button
                          onClick={() => setMoreFilter("default")}
                          className="rounded input_focus_shadow bg-white px-[9px] py-[4px]"
                        >
                          <HiOutlineChevronLeft />
                        </button>
                        <span className="font-semibold">Filter by Delinquent</span>
                      </div>
                      <div className="relative mt-3 w-full">
                        <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none">
                          <option value="is delinquent">is delinquent</option>
                          <option value="is paid up">is paid up</option>
                        </select>
                        <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[25px]" />
                      </div>
                      <button className="mt-[15px] w-full text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] p-[5px_10px]">
                        Apply
                      </button>
                    </div>
                  )}
                </PopoverContent>
              </Popover>
              {data.email !== "" ||
                data.card !== "" ||
                data.type !== "" ||
                data.date !== "" ? (
                <button
                  className="text-[14px] text-[#625afa] font-semibold"
                  onClick={clearFilter}
                >
                  Clear filters
                </button>
              ) : null}
            </div>
            {first.length !== 0 ? (
              <div className="flex gap-2 items-center">
                <span className="text-gray-600 text-[14px]">
                  {first.length} selected
                </span>
                <div className="mx-[10px] h-[28px] w-[1px] bg-gray-400" />
                <button className="border-b-[1px] mr-2 hover:border-double border-gray-600 text-[14px] text-[#414552] font-semibold border-dashed">
                  Deselect
                </button>
                <button
                  className="border-[2px] h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2"
                  onClick={() => setCopyData(true)}
                >
                  <CopyIcon />
                  Copy
                </button>
                <button
                  className="border-[2px] h-[30px] rounded-[8px] bg-[#df1b41] border-[##df1b41] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]"
                  onClick={() => setDeleteCust(true)}
                >
                  Delete
                </button>
              </div>
            ) : (
              <div className="flex gap-2 justify-end">
                <Popover
                  placement="left"
                  open={openPopover}
                  handler={setOpenPopover}
                  animate={{
                    mount: { scale: 1, y: 0 },
                    unmount: { scale: 0, y: 25 },
                  }}
                >
                  <PopoverHandler {...triggers}>
                    <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 opacity-60">
                      <CopyIcon />
                      Copy
                    </button>
                  </PopoverHandler>
                  <PopoverContent
                    {...triggers}
                    className="max-w-[300px] w-full xs:text-sm text-[13px] text-[#414552]"
                  >
                    <div>
                      This account has 0 stored Customer objects. Sharing
                      accounts must have Customer objects stored in order to
                      process a data copy. We are not able to copy Guest
                      customers. More information about Guest customers can be
                      found
                    </div>
                    <span className="text-[#635bff] cursor-pointer font-semibold">
                      here
                    </span>
                  </PopoverContent>
                </Popover>
                <button
                  className="input_focus_shadow h-[30px] rounded-[6px] xs:text-sm text-[13px] font-semibold p-[0_8px] flex items-center gap-2"
                  onClick={() => { setActive(true); setSendData('customer') }}
                >
                  <ExportIcon />
                  Export
                </button>
                <Popover placement="bottom-end">
                  <PopoverHandler>
                    <button className="input_focus_shadow h-[30px] rounded-[6px] xs:text-sm text-[13px] font-semibold p-[0_8px] flex items-center gap-2">
                      <EditIcon />
                      Edit Columns
                    </button>
                  </PopoverHandler>
                  <PopoverContent className="max-w-[250px] w-full px-0 text-[14px] py-[8px]">
                    <div className="px-[10px] border-b-[1px] pb-[8px] border-[#d5dde1]">
                      <span className="uppercase text-[#687385] text-[11px]">
                        Fixed columns
                      </span>
                      <div className="py-[4px]">Name</div>
                      <div className="h-[1px] w-full bg-[#d5dde1] my-[8px]"></div>
                      <div>
                        <span className="uppercase text-[#687385] text-[11px]">
                          Active Columns
                        </span>
                        <div className="flex justify-between text-[#404152] mt-2">
                          <div className="relative flex items-center">
                            <div className="flex items-center">
                              <input
                                id="id"
                                name="active-column"
                                type="checkbox"
                                className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                value={userInfo.customerID}
                                checked={userInfo.customerID}
                                onChange={() =>
                                  setUserInfo({
                                    ...userInfo,
                                    customerID: !userInfo.customerID,
                                  })
                                }
                              />
                            </div>
                            <div className="ml-3 text-sm translate-y-[1px]">
                              <label htmlFor="id" className="select-none font-normal">
                                Customer ID
                              </label>
                            </div>
                          </div>
                          <div className="flex cursor-pointer">
                            <BsThreeDotsVertical className="text-gray-500" />
                            <BsThreeDotsVertical className="text-gray-500 ml-[-8px]" />
                          </div>
                        </div>
                        <div className="flex justify-between text-[#404152] mt-2">
                          <div className="relative flex items-center">
                            <div className="flex items-center">
                              <input
                                id="name"
                                name="active-column"
                                type="checkbox"
                                className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                value={userInfo.cardName}
                                checked={userInfo.cardName}
                                onChange={() =>
                                  setUserInfo({
                                    ...userInfo,
                                    cardName: !userInfo.cardName,
                                  })
                                }
                              />
                            </div>
                            <div className="ml-3 text-sm translate-y-[1px]">
                              <label htmlFor="name" className="select-none font-normal">
                                Cardholder name
                              </label>
                            </div>
                          </div>
                          <div className="flex cursor-pointer">
                            <BsThreeDotsVertical className="text-gray-500" />
                            <BsThreeDotsVertical className="text-gray-500 ml-[-8px]" />
                          </div>
                        </div>
                        <div className="flex justify-between text-[#404152] mt-2">
                          <div className="relative flex items-center">
                            <div className="flex items-center">
                              <input
                                id="customer"
                                name="active-column"
                                type="checkbox"
                                className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                value={userInfo.customer}
                                checked={userInfo.customer}
                                onChange={() =>
                                  setUserInfo({
                                    ...userInfo,
                                    customer: !userInfo.customer,
                                  })
                                }
                              />
                            </div>
                            <div className="ml-3 text-sm translate-y-[1px]">
                              <label
                                htmlFor="customer"
                                className="select-none font-normal"
                              >
                                Customer
                              </label>
                            </div>
                          </div>
                          <div className="flex cursor-pointer">
                            <BsThreeDotsVertical className="text-gray-500" />
                            <BsThreeDotsVertical className="text-gray-500 ml-[-8px]" />
                          </div>
                        </div>
                        <div className="flex justify-between text-[#404152] mt-2">
                          <div className="relative flex items-center">
                            <div className="flex items-center">
                              <input
                                id="created"
                                name="active-column"
                                type="checkbox"
                                className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                value={userInfo.created}
                                checked={userInfo.created}
                                onChange={() =>
                                  setUserInfo({
                                    ...userInfo,
                                    created: !userInfo.created,
                                  })
                                }
                              />
                            </div>
                            <div className="ml-3 text-sm translate-y-[1px]">
                              <label
                                htmlFor="created"
                                className="select-none font-normal"
                              >
                                Created
                              </label>
                            </div>
                          </div>
                          <div className="flex cursor-pointer">
                            <BsThreeDotsVertical className="text-gray-500" />
                            <BsThreeDotsVertical className="text-gray-500 ml-[-8px]" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="px-[10px]">
                      <div className="mt-[8px]">
                        <div>
                          <span className="uppercase text-[#687385] text-[11px]">
                            Available Columns
                          </span>
                          <div className="flex justify-between text-[#404152] mt-2">
                            <div className="relative flex items-center">
                              <div className="flex items-center">
                                <input
                                  id="default"
                                  name="active-column"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userInfo.defaultMethod}
                                  checked={userInfo.defaultMethod}
                                  onChange={() =>
                                    setUserInfo({
                                      ...userInfo,
                                      defaultMethod: !userInfo.defaultMethod,
                                    })
                                  }
                                />
                              </div>
                              <div className="ml-3 text-sm translate-y-[1px]">
                                <label
                                  htmlFor="default"
                                  className="select-none font-normal"
                                >
                                  Default Payment method
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-between text-[#404152] mt-2">
                            <div className="relative flex items-center">
                              <div className="flex items-center">
                                <input
                                  id="email"
                                  name="active-column"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userInfo.email}
                                  checked={userInfo.email}
                                  onChange={() =>
                                    setUserInfo({
                                      ...userInfo,
                                      email: !userInfo.email,
                                    })
                                  }
                                />
                              </div>
                              <div className="ml-3 text-sm translate-y-[1px]">
                                <label
                                  htmlFor="email"
                                  className="select-none font-normal"
                                >
                                  Email
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-between text-[#404152] mt-2">
                            <div className="relative flex items-center">
                              <div className="flex items-center">
                                <input
                                  id="subscription"
                                  name="active-column"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userInfo.subscription}
                                  checked={userInfo.subscription}
                                  onChange={() =>
                                    setUserInfo({
                                      ...userInfo,
                                      subscription: !userInfo.subscription,
                                    })
                                  }
                                />
                              </div>
                              <div className="ml-3 text-sm translate-y-[1px]">
                                <label
                                  htmlFor="subscription"
                                  className="select-none font-normal"
                                >
                                  Subscription
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-between text-[#404152] mt-2">
                            <div className="relative flex items-center">
                              <div className="flex items-center">
                                <input
                                  id="Description"
                                  name="active-column"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userInfo.description}
                                  checked={userInfo.description}
                                  onChange={() =>
                                    setUserInfo({
                                      ...userInfo,
                                      description: !userInfo.description,
                                    })
                                  }
                                />
                              </div>
                              <div className="ml-3 text-sm translate-y-[1px]">
                                <label
                                  htmlFor="Description"
                                  className="select-none font-normal"
                                >
                                  Description
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            )}
          </div>
          {loader ? (
            ""
          ) : (
            <CustomerTable
              setFirst={setFirst}
              customers={customers}
              loader={loader}
              userInfo={userInfo}
            />
          )}
          {!loader && customers.length === 0 && (
            <div className="min-h-[546px] flex w-full items-center justify-center">
              <div className="max-w-[496px] p-[48px]">
                <div className="p-[12px] w-max rounded-[8px] bg-[#f6f8fa]">
                  <PersonIcon />
                </div>
                <div className="mt-6">
                  <span className="text-[20px] font-bold text-[#1a1b25]">
                    Add your first test customer
                  </span>
                </div>
                <p className="text-sm">
                  Bill customers with one-off or recurring invoices, or
                  subscriptions.
                </p>
                <button className="text-[#625afa] flex items-center font-medium gap-1">
                  Learn more{" "}
                  <BiRightArrowAlt className="text-[20px] translate-y-[2px]" />
                </button>
                <button
                  className="mt-5 flex gap-2 text-white font-semibold bg-[#635bff] rounded-[6px] text-[14px] items-center p-[5px_10px]"
                  onClick={() => setOpen(true)}
                >
                  <AiOutlinePlus />
                  Add a test customer
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddCustomerModel open={open} setOpen={setOpen} custInfo='' />
      <ExportModel active={active} setActive={setActive} sendData={sendData} />
      <DeleteCustomerModel
        deleteCust={deleteCust}
        setDeleteCust={setDeleteCust}
        id={first}
        setFirst={setFirst}
        setGetCust={setGetCust}
        getCust={getCust}
      />
      <CopydataModal
        copyData={copyData}
        setCopyData={setCopyData}
        cancelRequest={cancelRequest}
        setCancelRequest={setCancelRequest}
      />
    </>
  );
};

export default Customer;
